<div class="version-notes-dialog">
  <div class="dialog-header">
    <div>
      <h5 class="dialog-title">Release notes</h5>
      <p class="dialog-sub">
        Actueel: <strong>v{{ data.currentVersion }}</strong>
        <span *ngIf="data.buildRef"> · <code>{{ data.buildRef }}</code></span>
      </p>
    </div>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="close()"></button>
  </div>

  <div class="dialog-body">
    <ul class="version-list"
        role="listbox"
        [attr.aria-label]="'Productversies'">
      <li *ngFor="let entry of registry"
          role="option"
          class="version-item"
          [class.is-selected]="selected.version === entry.version"
          [attr.aria-selected]="selected.version === entry.version"
          (click)="select(entry)"
          (keydown.enter)="select(entry)"
          tabindex="0">
        <span class="version-badge">v{{ entry.version }}</span>
        <span class="version-date">{{ entry.dateLabel }}</span>
        <span class="version-tag" *ngIf="isCurrent(entry)">actueel</span>
      </li>
    </ul>

    <aside class="version-detail" *ngIf="selected">
      <h6 class="detail-heading">v{{ selected.version }}</h6>
      <p class="detail-date">{{ selected.dateLabel }}</p>
      <p class="intro">{{ selected.intro }}</p>

      <section *ngFor="let section of selected.sections" class="notes-section">
        <h6>{{ section.title }}</h6>
        <ul>
          <li *ngFor="let item of section.items">{{ item }}</li>
        </ul>
      </section>

      <p class="doc-hint muted">
        Volledige tekst: <code>{{ selected.docPath }}</code>
      </p>
    </aside>
  </div>

  <div class="dialog-footer">
    <button type="button" class="btn btn-secondary btn-sm" (click)="close()">Close</button>
  </div>
</div>
